import { Item } from "..";
import { DesignPriceCalculatorRuleBased } from "../../../../libs/pricingRuleBase/DesignPriceCalculatorRuleBased";

export class PlatformAttributeSelection {
    constructor(
        public attributeCode: string,
        public optionCode: string,
        public attributeLabel: string,
        public optionLabel: string,
        public attributeIsEnabled: boolean,
        public optionIsEnabled: boolean
    ) { }
}

export interface Integration {
    addToCart(composition: any, design: any, model: any, attributes: PlatformAttributeSelection[], designItems: Item[], quantity: number, additionalProperties: Record<string, any>): void;
    getPrice(composition: any, design: any, model: any, attributes: PlatformAttributeSelection[], compositionPrice: number, isCustomPricingConfiguratorEnabled: boolean, isCustomPricingRuleBasedEnabled: boolean, quantity: number): Promise<number | { price: number, isOutOfStock: boolean }>;
    getSharedCompositionUrl(compositionDocID: string): Promise<{ url: string }>;
    setPricingCalculator(pricingCalculator: DesignPriceCalculatorRuleBased): void;
    close(): void;
    setPricingCalculator(pricingCalculator: DesignPriceCalculatorRuleBased): void;
}